import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

const heroBg =
  "https://images.unsplash.com/photo-1752225494606-ae09aca08bea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwYmxhY2slMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzc3NjU1OTMxfDA&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  const { t } = useI18n();
  const pillars = [
    { t: t("hero.pillar1_t"), d: t("hero.pillar1_d") },
    { t: t("hero.pillar2_t"), d: t("hero.pillar2_d") },
    { t: t("hero.pillar3_t"), d: t("hero.pillar3_d") },
    { t: t("hero.pillar4_t"), d: t("hero.pillar4_d") },
  ];
  return (
    <section data-testid="hero-section" className="relative overflow-hidden border-b border-white/10">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-25"
        style={{ backgroundImage: `url(${heroBg})` }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/40 via-zinc-950/85 to-zinc-950" aria-hidden />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-12 pt-24 pb-32 sm:pt-32 sm:pb-44">
        <div className="flex items-center gap-3 mb-10 reveal-up">
          <span className="block w-8 h-px bg-white/40" />
          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-zinc-400">
            {t("hero.label")}
          </span>
        </div>

        <h1
          data-testid="hero-heading"
          className="font-display text-4xl sm:text-6xl lg:text-7xl font-semibold tracking-tighter leading-[1.05] max-w-4xl reveal-up"
          style={{ animationDelay: "60ms" }}
        >
          {t("hero.title_a")}
          <em className="italic text-zinc-300">{t("hero.title_em")}</em>
          {t("hero.title_b")}
        </h1>

        <p
          className="mt-8 max-w-xl text-base sm:text-lg leading-relaxed text-zinc-400 reveal-up"
          style={{ animationDelay: "140ms" }}
        >
          {t("hero.subtitle")}
        </p>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 reveal-up" style={{ animationDelay: "220ms" }}>
          <Link
            to="/simulateur"
            data-testid="hero-cta-simulateur"
            className="group inline-flex items-center justify-center gap-2 bg-white text-zinc-950 hover:bg-zinc-200 transition-colors px-7 py-4 text-sm font-medium tracking-wide"
          >
            {t("hero.cta.simulate")}
            <ArrowUpRight
              size={16}
              className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </Link>
          <a
            href="#portfolio"
            data-testid="hero-cta-portfolio"
            className="inline-flex items-center justify-center gap-2 border border-white/20 hover:border-white/60 transition-colors px-7 py-4 text-sm font-medium tracking-wide text-zinc-100"
          >
            {t("hero.cta.work")}
          </a>
        </div>

        {/* Pillars (no fake numbers) */}
        <div
          className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 reveal-up"
          style={{ animationDelay: "300ms" }}
        >
          {pillars.map((p, idx) => (
            <div key={idx} className="bg-zinc-950 px-6 py-7">
              <p className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-3">
                0{idx + 1}
              </p>
              <p className="font-display text-2xl tracking-tighter mb-2">{p.t}</p>
              <p className="text-xs text-zinc-400 leading-relaxed">{p.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
